export default __webpack_public_path__ + "static/ablr-badge-1-5a77e9f6b3b3d7988672340796565ed7.webp";